import { withInstall } from '@code-monkey-ui/utils'
import TooltipV2 from './src/tooltip.vue'

export const ElTooltipV2 = withInstall(TooltipV2)
export * from './src/arrow'
export * from './src/content'
export * from './src/root'
export * from './src/tooltip'
export * from './src/trigger'
export * from './src/constants'

export default ElTooltipV2
